
import React, { useState } from 'react';
import { Box, Typography, Grid, IconButton, Menu, MenuItem } from '@mui/material';
import ShimmerLoader from '../ShimmerLoader';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomRadarChart from '../CustomRadarChart';
import { menuItemSx } from '../../styles/GlobalStyles';
const CallAnalysisGrid = ({ displayData, filter, assistantId, downloadCallAnalysisReport, loading }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleDownload = (event) => {
    event.stopPropagation();
    downloadCallAnalysisReport({ filter, assistant: assistantId, organization: null });
    setAnchorEl(null);
  };

  const hasData = displayData?.callAnalysis?.transferedResult || 
                  displayData?.callAnalysis?.goalAchievementResult || 
                  displayData?.callAnalysis?.userSatisfactionResult || 
                  displayData?.callAnalysis?.scriptAdherenceResult || 
                  displayData?.callAnalysis?.callAbandonmentResult;

  const chartData = [
    { name: "Call Transferred", value: displayData.callAnalysis?.transferedResult || 0 },
    { name: "Goal Achievement", value: displayData.callAnalysis?.goalAchievementResult || 0 },
    { name: "User Satisfaction", value: displayData.callAnalysis?.userSatisfactionResult || 0 },
    { name: "SOP Adherence (%)", value: displayData.callAnalysis?.scriptAdherenceResult || 0 },
    { name: "Call Abandonment", value: (displayData.callAnalysis?.callAbandonmentResult || 0).toFixed(2) },
  ];

  const renderChart = (height) => (
    hasData ? (
      <Box sx={{ height: height}}>
        <CustomRadarChart data={chartData} />
      </Box>
    ) : (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
          No data found for applied filters.
        </Typography>
      </Box>
    )
  );

  return (
    <Grid item xs={12} md={6}>
      <Box
        sx={{
          p:4,
          cursor: "pointer",
          height: '100%',
          borderRadius: '12px',
          border: '1px solid #E5E7EB',
          bgcolor: 'white',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'scale(1.01)',
            bgcolor: '#F5F5F5',
            cursor: 'pointer',
          }
        }}
      >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box>
            <Typography variant="h6" color="text.primary">
              Call Analysis
            </Typography>
           <Typography sx={{ color: "#6A6A6A", fontSize: "0.9rem" }}>
                  Insights on call performance on various factors.
            </Typography>
            </Box>
            <IconButton 
              size="small" 
              onClick={handleMenuClick} 
              sx={{ color: 'text.secondary' }}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
          {loading ? (
            <ShimmerLoader height="200px" />
          ) : (
            renderChart(200)
          )}
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          elevation: 2,
          sx: {
              overflow: 'visible',
              mt: 1.2, // Slightly reduced margin top
              borderRadius: '8px', // Slightly tighter border radius
              minWidth: '200px', // Reduced width
              '& .MuiList-root': {
              padding: '8px' // Slightly reduced padding
              },
              '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 16,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
              },
          },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleDownload} sx={menuItemSx}>
          <FileDownloadIcon fontSize="small" sx={{ mr: 1 }} />
          Download Report
        </MenuItem>
      </Menu>
    </Grid>
  );
};

export default CallAnalysisGrid;
